import { render, staticRenderFns } from "./TemplateProductPodAssignerModal.vue?vue&type=template&id=5f7d73af"
import script from "./TemplateProductPodAssignerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateProductPodAssignerModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports